module.exports = __webpack_public_path__ + "media/epasnets-video-header-min.c7ece852.mp4";